import React, { ReactNode } from 'react';
import Button from '@v2/shared/components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';

import Section from '@v2/shared/components/Section';
import SliderButton from './SliderButton';

type Props = {
  /** Optional: a band whose section already carries the heading renders without one. */
  title?: string;
  viewAllLink?: string;
  children: ReactNode;
  next: () => void;
  nextDisabled: boolean;
  prev: () => void;
  prevDisabled: boolean;
};

export default function SliderSection({ title, viewAllLink, next, prev, prevDisabled, nextDisabled, children }: Props) {
  return (
    <Section>
      <Section.Header>
        {/* The header is justify-between, so an untitled band still needs something on
            the left to keep the scroll buttons against the right edge. */}
        {title ? <Section.Title>{title}</Section.Title> : <span />}
        {viewAllLink && (
          <a href={viewAllLink} className="md:hidden text-xs font-semibold text-slate-600">
            View all <FontAwesomeIcon icon={faLongArrowRight} />
          </a>
        )}
        <span className="flex max-md:hidden">
          <SliderButton
            onClick={prev}
            aria-label="Scroll products to the left"
            disabled={prevDisabled}
            direction="left"
            className="mr-2"
          />
          <SliderButton
            onClick={next}
            aria-label="Scroll products to the right"
            disabled={nextDisabled}
            direction="right"
          />
        </span>
      </Section.Header>
      <Section.Content>
        {children}
        {viewAllLink && (
          <div className="flex max-md:hidden items-center justify-center mt-3">
            <Button color="secondary" size="sm" onClick={() => { window.location.href = viewAllLink; }}>
              View All <FontAwesomeIcon icon={faLongArrowRight} className="ml-1.5" />
            </Button>
          </div>
        )}
      </Section.Content>
    </Section>
  );
}
